import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";

export const GET_STORY_BY_ID = gql`
  query GetStoryById($id: ID!) {
    storyByID(id: $id) {
      title
      portrait
      bicID
      vrDirectLink
      icon {
        iconValue
        color
      }
      gradient
      color
      user {
        avatar {
          ...imageFields
        }
        position
      }
      image {
        ...imageFields
      }
      cards {
        image {
          ...imageFields
        }
        layout
        highlightPosition
#          imagePosition
        backgroundVideo {
          title
          author
          authorUrl
          thumbnailUrl
          thumbnailHeight
          thumbnailWidth
          src
        }
        backgroundImage {
          ...imageFields
        }
        textHeading
        text
        time
        title
        embedVideo {
          title
          author
          authorUrl
          thumbnailUrl
          thumbnailHeight
          thumbnailWidth
          src
        }
        lottieAnimation
        theme
      }
      nextStories {
        title
        description
        stories {
          avatar {
            ...imageFields
          }
          title
          linkTitle
          storyId
        }
      }
      quizLink
      jobName
      schoolProfile {
        uuid
      }
    }
  }
  ${ImageFragment}
`;
